// ClientApp/src/public/tests/PgPubTestAuth.jsx
import useBogsGisPortalAuth from "@cores/security/hooks/useBogsGisPortalAuth";
import SsoAuthVerificationFlow from "@apps/components/tests/SsoAuthVerificationFlow";

export default function PgPubTestAuth() {
  const {
    loading,
    signedIn,
    portalUser,
    niogemsAuth,
    niogemsLoading,
    statusMsg,
    fetchNiogemsToken,
    logout,
  } = useBogsGisPortalAuth(false); // isProductionFlow = false

  if (loading) {
    return (
      <div style={{ padding: "20px", fontSize: "18px" }}>
        <strong>Checking Portal identity status...</strong>
      </div>
    );
  }

  if (!signedIn) {
    return (
      <div style={{ padding: "20px", color: "red", fontSize: "18px" }}>
        <strong>Not signed in to Portal — Redirecting/Access Denied...</strong>
      </div>
    );
  }

  return (
    <SsoAuthVerificationFlow
      statusMsg={statusMsg}
      portalUser={portalUser}
      niogemsAuth={niogemsAuth}
      niogemsLoading={niogemsLoading}
      fetchNiogemsToken={fetchNiogemsToken}
      logout={logout}
    />
  );
}